/* eslint-disable react-hooks/exhaustive-deps */
import showReplacementsOnProduct from '@/utils/replacements'
import { trackEvent } from '@mercadoni/sinister/dist/cjs/monitors/services'
import { ClientModel } from '@mercadoni/sinister/dist/lib/src/entities/clientModel'
import React, { createContext, useCallback, useMemo, useState } from 'react'
import { ProductCatalog } from '~types/index'

interface ReplacementsContextProps {
  openReplacements: () => void
  openModal: boolean
  closeReplacements: () => void
  onAddProduct: (props: { product: ProductCatalog }) => void
  setOpenModal: (open: boolean) => void
  selectedProduct: ProductCatalog | null
  setSelectedProduct: (product: ProductCatalog | null) => void
  clientConfig?: ClientModel
}

const ReplacementsContext = createContext<ReplacementsContextProps | null>(null)

export const ReplacementsProvider = ({ ...props }) => {
  const { clientConfig, configurations } = props
  const [openModal, setOpenModal] = useState(false)
  const [selectedProduct, setSelectedProduct] = useState<ProductCatalog | null>(
    null
  )

  const onAddProduct = ({ product }: { product: ProductCatalog }) => {
    const hasReplacements = product?.stockWarning

    const showReplacements = showReplacementsOnProduct(
      clientConfig,
      configurations
    )

    if (hasReplacements && showReplacements) {
      setSelectedProduct(product)
      setOpenModal(true)
    }
  }

  const closeReplacements = useCallback(() => {
    setOpenModal(false)
    trackEvent({
      eventName: 'replacements_cancelled',
    })
  }, [])

  const openReplacements = useCallback(() => {
    setOpenModal(true)
    trackEvent({
      eventName: 'open_replacements',
    })
  }, [])

  const value = useMemo(
    () => ({
      openReplacements,
      openModal,
      setOpenModal,
      closeReplacements,
      onAddProduct,
      selectedProduct,
      setSelectedProduct,
    }),
    [
      openReplacements,
      openModal,
      closeReplacements,
      onAddProduct,
      selectedProduct,
    ]
  )

  return (
    <ReplacementsContext.Provider value={value}>
      {props.children}
    </ReplacementsContext.Provider>
  )
}

export const useReplacementsContext = () => {
  const context = React.useContext(ReplacementsContext)
  if (!context) {
    throw new Error('useReplacements: No context')
  }
  return context
}
